const styles = {
    display: "flex",
    justifyContent: "end",
    flexDirection: "column",
    gap: "12px",
};

const inputStyles = {
    padding: "clamp(12px, 2vw, 16px)",
    paddingLeft: "clamp(14px, 2.5vw, 19px)",
    borderRadius: "5px",
    color: "black",
    fontFamily: "var(--font-paragraph)",
    fontSize: "17px",
    resize: "vertical"
};

const textAreaStyles = {
    padding: "clamp(12px, 2vw, 16px)",
    paddingLeft: "clamp(14px, 2.5vw, 19px)",
    borderRadius: "5px",
    color: "black",
    fontWeight: "500",
    fontFamily: "var(--font-paragraph)",
    width: "100%",
    fontSize: "17px",
    padding: "16px",
    minHeight: "120px",
    resize: "vertical",
};

const labelStyles = {
    color: "#116C4A",
    fontWeight: "700",
    fontFamily: "var(--font-label",
    fontSize: "var(--font-label-size)"
};

export { styles, inputStyles, labelStyles, textAreaStyles };